module.exports = __webpack_public_path__ + "static/img/icon_game_7.f253127.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_7.png
// module id = Cnyk
// module chunks = 0